<template>
  <v-card class="my-1">
    <v-toolbar flat dense>
      <v-toolbar-title>Erscheinungsbild</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="preview-wrap">
        <image-chooser
          :value="backgroundImage.currentValue"
          subject="Hintergrundbild"
          image-type="bg_spendeapp"
          :upload-field-rules="backgroundUploadRules"
          :initial-value="backgroundImage.currentFrame.value"
          :featured-values="['0wg85erb0lS,Eqr+6+2Wuqub88QrZ9Ppy;DTYuDkh8w']"
          large
          :activator-aspect-ratio="2"
          @input="val => $emit('input', { key: backgroundImage.key, value: val })"
          @upload-file="$emit('upload', { setting: backgroundImage, fileElement: $event, types: ['bg_spendeapp'] })"
        >
          <template v-slot:uploadText>
            <v-col cols="12">Eigenes Bild in hoher Auflösung (min. 1600&times;1200 Pixel, max. 10&nbsp;MB) hochladen. Bitte verletzen Sie dabei keine Urheberrechte.</v-col>
          </template>
          <template v-slot:overlay="{ element }">
            <hand-square class="brand-overlay" :style="{ '--hand-color': freeColor.currentValue }" size="88px" />
            <div v-if="element && element.image && element.image.name" class="file-overlay" :style="{ color: freeColor.currentValue }">
              {{ element.image.name }}<template v-if="element.image.width && element.image.height"> ({{ element.image.width }}&times;{{ element.image.height }})</template>
            </div>
            <div class="color-overlay" @click.stop>
              <button
                v-for="c in freeColorSwatches"
                :key="c"
                type="button"
                class="swatch"
                :class="{ 'swatch--selected': isSelected(c) }"
                :style="{ background: c }"
                :aria-label="'Farbe ' + c"
                @click="pickColor(c)"
              ></button>
              <button type="button" class="swatch swatch--custom" aria-label="Eigene Farbe" @click="customPickerOpen = true">
                <v-icon x-small color="white">{{ mdiPencil }}</v-icon>
              </button>
            </div>
          </template>
        </image-chooser>
        <reset-icon class="preview-wrap__reset" :setting="backgroundImage" @clear="$emit('clear', backgroundImage.key)" @set-here="$emit('set-here', backgroundImage.key)" />
      </div>
      <div class="d-flex align-center mt-1">
        <span class="text-caption text--secondary">Grundfarbe der App</span>
        <reset-icon :setting="freeColor" @clear="$emit('clear', freeColor.key)" @set-here="$emit('set-here', freeColor.key)" />
      </div>
    </v-card-text>

    <v-dialog v-model="customPickerOpen" max-width="340">
      <v-card>
        <v-card-text class="pt-4">
          <v-color-picker
            :value="freeColor.currentValue"
            @input="val => $emit('input', { key: freeColor.key, value: val })"
            dot-size="15"
            mode="hexa"
            show-swatches
            :swatches="freeColorSwatches.map(c => [c])"
            swatches-max-height="113"
          ></v-color-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="customPickerOpen = false">Fertig</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mdiPencil } from '@mdi/js'
import ResetIcon from '@/components/device/ResetIcon'
import ImageChooser from '@/components/device/ImageChooser'
import HandSquare from '@/components/icons/HandSquare'

export default {
  name: 'AppearanceGroup',
  components: { ResetIcon, ImageChooser, HandSquare },
  props: {
    backgroundImage: {
      type: Object,
      required: true,
    },
    freeColor: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      mdiPencil,
      customPickerOpen: false,
      freeColorSwatches: ['#554193', '#ae364b', '#d7c548', '#03867b', '#005F8C'],
      backgroundUploadRules: [
        file => !file || !(file.size > 10485760) || 'Maximal 10 MB!'
      ],
    }
  },
  methods: {
    isSelected (c) {
      return String(this.freeColor.currentValue || '').toUpperCase() === c.toUpperCase()
    },
    pickColor (c) {
      this.$emit('input', { key: this.freeColor.key, value: c })
    },
  },
}
</script>

<style scoped>
.preview-wrap {
  position: relative;
  max-width: 800px;
}
.preview-wrap__reset {
  position: absolute;
  top: 4px;
  right: 4px;
}
.color-overlay {
  position: absolute;
  left: 12px;
  bottom: 12px;
  display: flex;
  gap: 8px;
}
.brand-overlay {
  position: absolute;
  left: 16px;
  top: 16px;
}
.brand-overlay /deep/ .cls-1 {
  fill: var(--hand-color);
}
.file-overlay {
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 22px;
  font-weight: 700;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swatch {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.swatch--selected {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(0, 0, 0, .5);
}
.swatch--custom {
  background: rgba(0, 0, 0, .35);
}
</style>
